import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import LoadingButton from "@mui/lab/LoadingButton";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import { TextField } from "formik-material-ui";
import { Grid } from "@mui/material";
import axios from "axios";
import { useTranslation } from "react-i18next";
import REACT_APP from "../../../../environment";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
};

function TransitionsModal({ getData }) {
    const { t } = useTranslation();
    const [loading, setLoading] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const validateCompany = Yup.object({
        name: Yup.string().required(t("name is required")),
        date: Yup.date().required(t("Date is required")),
        abbreviation: Yup.string().optional(),
    });
    const emptyData = {
        name: "",
        date: "",
        abbreviation: "",
    };

    const onSubmit = async (values) => {
        if (!values?.abbreviation.length) {
            delete values.abbreviation;
        }
        setLoading(true);
        await axios
            .post(`${REACT_APP.API}/api/hrp/v1/employee/certification`, values, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: sessionStorage.getItem("token"),
                },
            })
            .then((res) => {
                setLoading(false);
                toast.success(t("Saved successfully"));
                handleClose();
                getData();
            })
            .catch((err) => {
                setLoading(false);
                toast.error(t("An error occurred"));
            });
    };

    return (
        <div className="addcompany">
            {loading && <div className="hrp-overlay"></div>}
            <Button onClick={handleOpen} variant="contained">
                {t("Add certification")}
            </Button>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={open}>
                    <Box sx={style} className="addcompanymodal">
                        <Typography id="transition-modal-title" variant="h6" component="h2" className="marginBottom">
                            {t("Enter certification info")}
                        </Typography>
                        <Formik
                            initialValues={emptyData}
                            validationSchema={validateCompany}
                            onSubmit={async (values) => {
                                onSubmit(values);
                                return new Promise((res) => setTimeout(res, 500));
                            }}
                        >
                            {({ values, errors }) => (
                                <Form autoComplete="off" className="mt-4">
                                    <Grid item xs={12} className="marginBottom">
                                        <Field fullWidth name="name" label={t("name")} autoComplete="name" component={TextField} />
                                    </Grid>
                                    <Grid item xs={12} className="marginBottom">
                                        <Field fullWidth name="abbreviation" label={t("Abbreviation")} autoComplete="abbreviation" component={TextField} />
                                    </Grid>
                                    <Grid item xs={12} className="marginBottom">
                                        <label>{t("Date of Certification")}</label>
                                        <Field fullWidth name={t("date")} autoComplete="date" component={TextField} type="date" />
                                    </Grid>
                                    <div className="right_left">
                                        <Button onClick={handleClose} variant="contained" color="error">
                                            {" "}
                                            {t("Close")}
                                        </Button>
                                        <>
                                            {loading ? (
                                                <LoadingButton loading variant="contained" color="success">
                                                    {t("Submit")}
                                                </LoadingButton>
                                            ) : (
                                                <Button type="submit" variant="contained" color="success">
                                                    {t("Submit")}
                                                </Button>
                                            )}
                                        </>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
}

export default React.memo(TransitionsModal);
